import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel,buttonLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title" variant='h5' textAlign={'center'}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="contained" color="primary">
          Cancel
        </Button>
       {/*  <Button onClick={onConfirm} color="primary" autoFocus  variant="outlined">
          Confirm
        </Button> */}
        <Button variant={'outlined'}  color="primary" type="button" onClick={onConfirm}   >{buttonLoading ?  <CircularProgress size={24} sx={{ color: '#8baf91' }} /> : 'Confirm'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
